module.exports = __webpack_public_path__ + "static/img/sec1-main-img@w.6894cfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec1-main-img@w.jpg
// module id = jnaJ
// module chunks = 0